import React, { Component } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Social from './Social'
import styles from './mobileLeftMenu.css'
import MenuItem from '../todayTask/MenuItem'
import classNames from 'classnames';
import {browserHistory} from 'react-router'

class MobileLeftMenu extends Component {
  render() {
    const { hideMenu, menuList, dayId, userInfo, isRegistered, isSimpleRegs } = this.props

    const error = {
      name: 'Нашел ошибку?',
      active: false,
      link: 'error-report',
      icon: 'ico-warning'
    }
    return (
      <div className={styles.menuMobLeft}>
        <div className={styles.menuMobLeftInner}>
          <div
            className={styles.menuMobLeftIcoClose}
            onClick={hideMenu}
          >
            <svg className={styles.svgIconClose}>
              <use xlinkHref="#ico-close"></use>
            </svg>
          </div>
          <div className={styles.menuMobLeftLogo}>
            <h1 className={styles.gridCellHeaderLogo}>
              <img src="/assets/img/els/logo.svg" width="220px" className={styles.uniproLogo} alt=""/>
            </h1>
          </div>
          { userInfo && userInfo.data.role === 4 && isRegistered && isSimpleRegs &&
          <button className={styles.btnAction} onClick={() => {
            hideMenu()
            browserHistory.push('/signup/params')
          }}>
            Принять участие
          </button>
          }
          <ul className={classNames(styles.mainNav, {
            [styles.hidden]: userInfo && userInfo.data.role === 4 && isRegistered
          })}>
            {menuList.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  item={item}
                  dayId={dayId}
                  onClick={hideMenu}
                />
              )
            })}
            <li className="main-nav__item--line"></li>
            <MenuItem
              item= {error}
              dayId={dayId}
              onClick={hideMenu}
            />
            <li className="main-nav__item--line"></li>
          </ul>
       {/*   <div className={styles.social}>
            <div className={styles.socialSignin}>
              <a className={styles.socialSigninItem} href="https://vk.com/todaymeru" target="blank">
                <svg className={styles.svgIconVk}>
                  <use xlinkHref="#vk"></use>
                </svg>
              </a>

              <a className={styles.socialSigninItem} href="https://www.instagram.com/todaymeru" target="blank">
                <svg className={styles.svgIconInsta}>
                  <use xlinkHref="#insta"></use>
                </svg>
              </a>

              <a className={styles.socialSigninItem} href="https://www.facebook.com/todaymeru" target="blank">
                <svg className={styles.svgIconFb}>
                  <use xlinkHref="#fb"></use>
                </svg>
              </a>

              <a className={styles.socialSigninItem} href="https://ok.ru/group/53371420672073" target="blank">
                <svg className={styles.svgIconOk}>
                  <use xlinkHref="#odnoklassniki"></use>
                </svg>
              </a>

              <a className={styles.socialSigninItem} href="https://www.youtube.com/channel/UC-mD0FrmH82u34-J5lFS-BA" target="blank">
                <svg className={styles.svgIconYoutube}>
                  <use xlinkHref="#youtube"></use>
                </svg>
              </a>
            </div>
          </div>*/}
          {/* <ul className="banner-ls banner-ls--menu-mob-left">
            <li className="banner-ls__item">
              <a href="#">
                <div className="banner-ls__img">
                  <img src="tmp/banner-2.png" alt="" />
                </div>
                <p className="banner-ls__desc">В твой выходной день только сегодня TezTour дарит -10% на тур</p>
              </a>
            </li>
            <li className="banner-ls__item">
              <a href="#">
                <div className="banner-ls__img">
                  <img src="tmp/banner-1.png" alt="" />
                </div>
              </a>
            </li>
          </ul> */}

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { menuList } = state
  return {
    menuList
  }
}

MobileLeftMenu = connect(
  mapStateToProps
)(MobileLeftMenu)

export default CSSModules(MobileLeftMenu, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/componentKit2/MobileLeftMenu.js